<div class="row waveform-area">
  <div class="col-md-3 text-center">
    <div class="row">
      <div class="col-md-12">
        <div class="upload-audio">

          <label class="btn btn-primary btn-block upload-btn" [ngClass]="{'disabled': uploading || storyboard.read_only}">
            <i class="fa fa-music"></i> Upload Audio File
            <input type="file" [disabled]="uploading || storyboard.read_only" accept=".mp3, .wav" ngFileSelect (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
          </label>

        </div>
      </div>
    </div>

    <div class="row time-area">
      <div class="col-md-12">
        <div class="duration-title">Duration:</div>
        <div class="duration-time">
          <span class="minute"><input type="text" maxlength="2" (blur)="onChangeDuration($event)" [(ngModel)]="duration.minutes" [disabled]="storyboard.read_only" /></span> : <span class="second"><input type="text" (blur)="onChangeDuration($event)" maxlength="2" [(ngModel)]="duration.seconds" [disabled]="storyboard.read_only" /></span>
        </div>
      </div>
    </div>

  </div>
  <div class="col-md-9 waveform-container" #waveformContainer [hidden]="!(storyboard.attached_audio && storyboard.attached_audio.media_waveform.url)">
    <app-waveform [storyboard]="storyboard" *ngIf="storyboard.attached_audio && storyboard.attached_audio.media_waveform.url"></app-waveform>
  </div>
  <div class="col-md-9" [hidden]="storyboard.attached_audio && storyboard.attached_audio.media_waveform.url">
    <div class="row">
      <div class="col-md-8 min-height-106">
        <div [ngClass]="{'hide' : uploading}">
          <div class="upload-drop-zone" ngFileDrop
               (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput"
               [ngClass]="{ 'is-drop-over': dragOver }" *ngIf="!storyboard.attached_audio && !storyboard.read_only">

            <div class="audio-upload-card">
              <div class="row">
                <div class="col-sm-12 text-center">
                  <img src="/assets/images/icons/blue_icons.png" alt="cards-upload"/>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 drop-text text-center">
                  Drop audio file or
                  <label class="upload-button">
                    <input type="file" accept=".mp3, .wav" ngFileSelect (uploadOutput)="onUploadOutput($event)" [uploadInput]="uploadInput">
                    browse
                  </label>
                  it from your computer
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-4" *ngIf="uploading">
          <div class="col-sm-6 offset-sm-3 text-center">
            <p class="mb-1" *ngIf="uploadPercent < 100"><ngb-progressbar class="mb-4" type="success" [value]="uploadPercent"></ngb-progressbar></p>
            <div class="percent-bar" *ngIf="uploadPercent < 100">
              <i class="fa fa-spin fa-spinner text-success"></i> <strong>Uploading Audio...</strong><br />
              <span class="remaining-size">{{ remaining }}</span> / {{ total }} ({{speed}})
            </div>
            <div class="percent-bar mt-3" *ngIf="uploadPercent === 100">
              <span class="remaining-size"><i class="fa fa-spin fa-spinner text-success"></i> <strong>Generating Waveform...</strong></span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 timebar-container" *ngIf="!(storyboard.attached_audio && storyboard.attached_audio.media_waveform.url)">
        <app-waveform [storyboard]="storyboard"></app-waveform>
      </div>
    </div>

  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/timeline/audio-track/audio-track.component.html